var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project",on:{"click":_vm.selectProject}},[_c('img',{staticClass:"ui tiny rounded image",attrs:{"src":_vm.imageUrl}}),_vm._v(" "),(_vm.displayText)?_c('h4',[_vm._v(_vm._s(_vm.displayText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }